module.exports = __webpack_public_path__ + "static/img/200297.c7ae2d85.png";